var map = {
	"./config-1deutsch.json": 517,
	"./config-80s80s.json": 518,
	"./config-90s90s.json": 519,
	"./config-amv.json": 520,
	"./config-barbaradio.json": 521,
	"./config-bob.json": 522,
	"./config-d1-rsh.json": 523,
	"./config-d2-delta-bob.json": 524,
	"./config-d3-rsh-delta-bob.json": 525,
	"./config-delta.json": 526,
	"./config-digital-berlin.json": 527,
	"./config-digital.json": 528,
	"./config-feierfreund.json": 529,
	"./config-psr.json": 530,
	"./config-redaktion-amv.json": 531,
	"./config-redaktion-bob.json": 532,
	"./config-redaktion-delta.json": 533,
	"./config-redaktion-rsh.json": 534,
	"./config-rsa.json": 535,
	"./config-rsh.json": 536,
	"./config-rzl1-psr-rsa.json": 537,
	"./config-rzl2-psr-rsa.json": 538,
	"./config-rzl3-psr-rsa.json": 539,
	"./config-rzl4-psr-rsa.json": 540,
	"./config-rzl5-psr.json": 541,
	"./config-rzl6-rsa.json": 542,
	"./config-schlagerplanet.json": 543,
	"./config-ssl.json": 544,
	"./config-weihnachtsmusik.json": 545
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/config\-.*\.json$
// module id = 516
// module chunks = 1